// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useSelector } from "react-redux";

import NameOrEmail from "src/containers/user/NameOrEmail";
import { getDisableUserModalData } from "src/reducers";

import { HeaderWrapper } from "./styles";

import type { UID } from "src/types";

type Props = {
  uid: UID,
};

const Header = ({ uid }: Props) => {
  const { adminModal, memberModal } = useSelector(({ app }) =>
    getDisableUserModalData(app),
  );
  const showDisable = !adminModal && !memberModal;

  if (memberModal) {
    return (
      <HeaderWrapper>
        {i18n.t(k.MAKE)} <NameOrEmail uid={uid} /> {i18n.t(k.ADMIN)}
      </HeaderWrapper>
    );
  } else if (adminModal) {
    return (
      <HeaderWrapper>
        {i18n.t(k.MAKE)} <NameOrEmail uid={uid} /> {i18n.t(k.MEMBER)}
      </HeaderWrapper>
    );
  } else if (showDisable) {
    return (
      <HeaderWrapper>
        {i18n.t(k.DISABLE)} <NameOrEmail uid={uid} />
        {i18n.t(k.S_ACCOUNT)}
      </HeaderWrapper>
    );
  }

  return null;
};

export default Header;
